<template>
	<button class="c-button"><slot></slot></button>
</template>

<script>
export default {
	name: 'button'
}
</script>



// WEBPACK FOOTER //
// app-button.vue?1aa5cec7